var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      staticStyle: { "padding-left": "80px" },
      nativeOn: {
        click: function($event) {
          return _vm.saveUserActivityTime($event)
        }
      }
    },
    [
      _c(
        "v-app-bar",
        {
          staticStyle: {
            "background-color": "#0031e2",
            color: "white",
            "padding-left": "80px",
            height: "64px"
          },
          attrs: { app: "" }
        },
        [
          _c(
            "v-toolbar-title",
            {
              staticStyle: { position: "relative", top: "4px", width: "500px" }
            },
            [
              _c("v-row", [
                _c(
                  "div",
                  { staticClass: "px-3", staticStyle: { width: "50px" } },
                  [
                    _vm.$store.state.Auth.isWntLoaded &&
                    _vm.$store.state.Auth.isWnt
                      ? _c("img", {
                          staticStyle: { height: "40px" },
                          attrs: {
                            alt: "Logo Why Not Travel",
                            src: "/img/logownt.jpg"
                          }
                        })
                      : _vm._e(),
                    _vm.$store.state.Auth.isWntLoaded &&
                    !_vm.$store.state.Auth.isWnt
                      ? _c("img", {
                          staticStyle: { height: "40px" },
                          attrs: {
                            alt: "Logo Why Not Travel",
                            src: "/img/logofollowup.png"
                          }
                        })
                      : _vm._e()
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "700",
                      top: "4px",
                      position: "relative",
                      width: "330px"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("global.title")) + " ")]
                )
              ])
            ],
            1
          ),
          _c("v-spacer"),
          !_vm.isWnbUser && !_vm.$store.getters["isAdmin"]
            ? _c(
                "v-toolbar-items",
                { staticStyle: { position: "relative" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          return _vm.chooseLang("pl")
                        }
                      }
                    },
                    [
                      _c("flag", {
                        staticStyle: { "font-size": "23px" },
                        attrs: { squared: false, iso: "pl" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          return _vm.chooseLang("en")
                        }
                      }
                    },
                    [
                      _c("flag", {
                        staticStyle: { "font-size": "23px" },
                        attrs: { squared: false, iso: "gb" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("main-menu"),
      _c(
        "v-content",
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "fixed",
                height: "12px",
                width: "100%",
                "z-index": "7"
              }
            },
            [
              _vm.loading
                ? _c("v-progress-linear", {
                    staticStyle: { margin: "0" },
                    attrs: { indeterminate: true, color: "accent" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm.isBrowserIE
            ? _c("v-alert", { attrs: { type: "error" } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("global.browserNotCompatible")) + " "
                )
              ])
            : _vm._e(),
          !_vm.online
            ? _c("v-alert", { attrs: { type: "warning" } }, [
                _vm._v(" " + _vm._s(_vm.$t("global.warning.offline")) + " ")
              ])
            : _vm._e(),
          _vm.update
            ? _c(
                "v-alert",
                { attrs: { type: "info" }, on: { click: _vm.reload } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("global.newVersionAvailable")) + " "
                  )
                ]
              )
            : _vm._e(),
          _c(
            "v-container",
            {
              staticClass: "justify",
              class: {
                "padding-main-container": true,
                "main-container": !_vm.$store.state.Visual.wideView,
                "gray-half-background": _vm.halfGrayBackground,
                "gray-menu-background": _vm.menuBackground,
                "gray-half-menu-background": _vm.halfMenuBackground
              },
              attrs: { fluid: "" }
            },
            [_c("router-view", [_vm._t("default")], 2)],
            1
          )
        ],
        1
      ),
      _vm.$store.state.Auth.isWnt
        ? _c(
            "div",
            {
              staticStyle: {
                "align-content": "center",
                "text-align": "center",
                "margin-bottom": "30px",
                "background-color": "white"
              }
            },
            [
              _c("a", { attrs: { href: "https://whynottravel.pl/" } }, [
                _c("img", { attrs: { src: "/img/banner.gif" } })
              ])
            ]
          )
        : _vm._e(),
      _vm.$store.state.Auth.isWntLoaded && !_vm.$store.state.Auth.isWnt
        ? _c(
            "v-col",
            {
              staticStyle: {
                "align-content": "center",
                "text-align": "center",
                "margin-bottom": "30px",
                "background-color": "white"
              }
            },
            [
              _c("v-img", {
                staticClass: "responsive",
                attrs: { src: "/img/logoeu.png" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.$vuetify.breakpoint.mdAndUp
        ? _c(
            "v-footer",
            {
              staticClass: "body-2 pa-0",
              staticStyle: { "z-index": "9" },
              attrs: { app: "" }
            },
            [
              _vm.$store.state.Auth.isWnt
                ? [
                    _c("div", { staticClass: "pull-left" }, [
                      _vm._v("© "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "http://whynottravel.pl",
                            rel: "external"
                          }
                        },
                        [_vm._v("WNT")]
                      ),
                      _vm._v(" 2019")
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "8px",
                          color: "darkgray"
                        }
                      },
                      [
                        _vm._v(" @ "),
                        _c(
                          "a",
                          {
                            staticStyle: { color: "darkgray" },
                            attrs: {
                              href: "http://solvsoft.pl/",
                              rel: "external"
                            }
                          },
                          [_vm._v("SolvSoft.pl")]
                        ),
                        _vm._v(
                          " Version 0.36.4 build date 2020-02-26 15:02:58, visual brand Nexocode "
                        )
                      ]
                    )
                  ]
                : [
                    _c("div", { staticClass: "pull-left" }, [
                      _vm._v("© "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://followup.pl",
                            rel: "external"
                          }
                        },
                        [_vm._v("FollowUp")]
                      ),
                      _vm._v(" 2019")
                    ])
                  ],
              _vm.$store.getters["isAuthenticated"]
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        color: "darkgray",
                        position: "absolute",
                        right: "8px"
                      }
                    },
                    [_vm._v("Inactivity logout: " + _vm._s(_vm.toLogout))]
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _c("confirm-dialog"),
      _c("alert-dialog"),
      _c("snackbar"),
      _c("prompt-dialog"),
      _c("div", {
        staticStyle: { display: "none" },
        attrs: { id: "clear-focus-element" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }